import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { fmtDate } from "@/lib/date";
import { useAuth } from "@/lib/auth";

export default function OrgPending({ readOnly, onChange, tick }) {
  const { refresh } = useAuth();
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(null);
  useEffect(() => { api.get("/users/pending").then((r) => setRows(r.data)).catch(() => {}); }, [tick]);
  const act = async (u, kind) => {
    if (kind === "reject" && !window.confirm(`Decline ${u.name}'s access request?`)) return;
    setBusy(u.id);
    try {
      await api.post(`/users/${u.id}/${kind}`, kind === "approve" ? {} : undefined);
      toast.success(kind === "approve" ? `${u.name} approved` : `${u.name} declined`);
      onChange();
      refresh();
    } catch (e) { toast.error(e?.response?.data?.detail || "Action failed"); }
    finally { setBusy(null); }
  };
  return (
    <Card className="p-4 sm:p-5" data-testid="org-pending">
      <h2 className="font-serif text-xl text-[#0A1F44] mb-3">Pending registrations ({rows.length})</h2>
      {!rows.length && <p className="text-sm text-slate-500" data-testid="org-pending-empty">No one is waiting for approval in your organisation.</p>}
      <ul className="divide-y divide-slate-100">
        {rows.map((u) => (
          <li key={u.id} className="py-3 flex flex-col sm:flex-row sm:items-center gap-2" data-testid={`org-pending-${u.id}`}>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-[#0A1F44] break-words">{u.name}</div>
              <div className="text-xs text-slate-500 break-all">{u.email} · {u.upline_team || "no team"} · requested {fmtDate(u.created_at)}</div>
            </div>
            {!readOnly && (
              <div className="flex gap-2">
                <Button size="sm" disabled={busy === u.id} onClick={() => act(u, "approve")} className="h-10 rounded-full bg-[#0A1F44] text-white" data-testid={`org-approve-${u.id}`}>Approve</Button>
                <Button size="sm" variant="outline" disabled={busy === u.id} onClick={() => act(u, "reject")} className="h-10 rounded-full" data-testid={`org-reject-${u.id}`}>Decline</Button>
              </div>
            )}
          </li>
        ))}
      </ul>
    </Card>
  );
}
